import { GuiOpenUrlWith } from '../api/v2/Models/GuiComponentApiModel';

export interface ComponentIdentityButtonSpecification {
	id: number;
	title: string;
	subtitle: string;
	url: string;
	openUrlWith: GuiOpenUrlWith;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
}

export class ComponentIdentityButton {
	public readonly id: number;
	public readonly title: string;
	public readonly subTitle: string;
	public readonly url: string;
	public readonly openUrlWith: GuiOpenUrlWith;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;

	constructor(spec: ComponentIdentityButtonSpecification) {
		this.id = spec.id;
		this.title = spec.title;
		this.subTitle = spec.subtitle;
		this.url = spec.url;
		this.openUrlWith = spec.openUrlWith;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
	}
}
